// Shared zoom-domain bus for synchronising chart zoom across all traces.
// Subscribers immediately receive the current value on subscribe (even null),
// so panels that mount after a zoom already in progress get the right domain.

let _current = null;
const _subs = new Set();

export function publishZoom(domain) {
  _current = domain ?? null;
  _subs.forEach(fn => fn(_current));
}

export function subscribeZoom(fn) {
  _subs.add(fn);
  fn(_current);
  return () => _subs.delete(fn);
}
